<template>
  <div id="landing-page-module" class="flex flex-col" :class="`bg-${props.backgroundColor}`">
    <div class="px-6 md:mx-0 w-full md:max-w-[1280px] flex flex-col items-center mb-16">
      <h1
        class="md:max-w-[720px] text-center mt-mobileNavBarHeight"
        v-html="landingPageContent.heading"
        v-if="landingPageContent.heading"
        data-test="landingPageHeading" />
      <h1 class="w-[80%] md:w-full text-center mt-[60px]" v-else>
        Financial advice for <span class="svg-underline">all</span>
      </h1>
      <h5
        class="mt-[40px] text-center max-w-[820px]"
        v-html="landingPageContent.subHeading"
        data-test="landingPageSubHeading" />
      <p
        v-if="landingPageContent.body"
        class="w-9/10 md:w-4/5 md:max-w-[954px] mt-[40px] text-center"
        v-html="landingPageContent.body" />

      <div class="mt-10 transform transition-all duration-1000 hover:scale-105">
        <slot name="svgComponent" />
      </div>

      <OtivoButton
        class="w-full md:max-w-[360px] mt-10"
        @click="$emit('ButtonClicked')"
        v-if="showButton"
        data-test="landingPageButton">
        Get in touch today
      </OtivoButton>

      <MediaLogos v-if="showLogos" class="hidden md:block md:mt-12" />
      <p v-if="showDisclaimerText" class="text-center paragraph-4 mt-12">
        *Otivo Super + Advice Report 2024
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import MediaLogos from '@/components/SVGS/MediaLogos.vue'
import OtivoButton from '@/components/OtivoButton.vue'

type LandingPageContentType = {
  heading: string
  subHeading: string
  body?: string
  buttonText: string
}

interface Props {
  showButton?: boolean
  buttonText?: string
  showLogos?: boolean
  showDisclaimerText?: boolean
  backgroundColor?: string
  landingPageContent: LandingPageContentType
}

const props = withDefaults(defineProps<Props>(), {
  backgroundColor: 'white',
  showLogos: true,
  showDisclaimerText: false,
  showButton: false,
  buttonText: 'Get started',
})

defineEmits(['ButtonClicked'])
</script>

<style scoped></style>
